<div class="card card-login" style="width: 130%" *ngIf="linkCheckErrorMessage">
  <div class="card-content">

    <!--logo section -->
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center" style="width: 50%; margin-left: 28%">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3 class="title hidden">able+</h3>
        </div>
      </div>
    </div>
    <!--logo section end-->

    <!--First step-->
    <div class="col" >
      <div class="input-group col-md-8 col-lg-8 col-sm-8 col-xs-8" style="margin-left: 18%">
        <h3 *ngIf="showHeader" style="text-align: center">Account in use</h3>
        <h5 style="text-align: center; margin-bottom: 30px; margin-top: 30px">{{linkCheckErrorMessage}}</h5>
      </div>
    </div>
  </div>
</div>
